<template>
  <transition name="modal">
    <div class="modal-mask"
         @mousedown="closeModal()"
         :class="modalClass"
         :style="overlayRightPosition">
      <div class="modal-wrapper">
        <div :class="this.containerStyle" class="modal-container"
             @mousedown="$event.stopPropagation()">
          <div class="modal-header">
            <slot name="header">
              default header
            </slot>

            <span class="modal-cancel"
                  :class="{'modal-cancel-grey': isNewDesign}"
                  @click="closeModal()">
              <icon name="cancel"
                    :width="iconWidth"
                    :color="iconColor">
              </icon>
            </span>
          </div>

          <div class="modal-body">
            <slot name="body">
              default body
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              default footer
              <button class="modal-default-button"
                      type="button"
                      @click="closeModal()">
                OK
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import Icon from '../icon/Icon.vue'

  const $html = document.querySelector('html');
  const $body = document.querySelector('body');

  const getScrollBarWidth = () => {
      const scrollDiv = document.createElement("div");
      scrollDiv.className = "scrollbar-measure";
      $body.appendChild(scrollDiv);

      const scrollBarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      $body.removeChild(scrollDiv);

      return scrollBarWidth;
  }

  const getBodyScrollBarWidth = () => window.innerWidth - $body.clientWidth;

  export default {
    name: 'modal',
    components: {
      Icon
    },
    data () {
        return {
            modalClass: {
              ['modal-mask--' + this.modalStyle]: this.modalStyle,
              'modal-mask--iframe': this.isInIframe,
            },
            scrollBarWidth : getScrollBarWidth(),
            scroll: 0
        }
    },
    computed: {
        iconColor() {
            if(this.modalStyle === 'mobile'){
                return 'white'
            } else {
                return 'black-grey'
            }
        },
        overlayRightPosition() {
            return {
                right: '-' + (this.scrollBarWidth + 1) + 'px'
            };
        }
    },
    props: {
        modalStyle: String,
        iconWidth: {
          type: Number,
          default: 22
        },
        isNewDesign: {
          type: Boolean,
          default: false
        },
      containerStyle: {
        type: String,
      },
      isInIframe: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      closeModal() {
        this.$emit('close');
      },
      scrollTo() {
        $body.style.position = 'static';
        $body.style.top = 0;
        $body.style.overflow = 'visible';

        if (!this.scroll) return;

        $html.scrollTop = this.scroll;
        $body.scrollTop = this.scroll;

        this.scroll = 0;
      }
    },
    mounted() {
      $body.style.paddingRight = getBodyScrollBarWidth() + 'px';

      this.scroll = $html.scrollTop || $body.scrollTop || this.scroll;
      $body.style.position = 'fixed';
      $body.style.top = '-' + this.scroll + 'px';
      $body.style.overflow = 'hidden';
      $body.classList.add('modal-open');
    },
    destroyed() {
      $body.removeAttribute('style');
      $body.classList.remove('modal-open');
      this.scrollTo();
    }
  }
</script>

<style lang="less">
    .scrollbar-measure {
        width: 100px;
        height: 100px;
        overflow: scroll;
        position: absolute;
        top: -9999px;
    }

    .modal-open {
        overflow: hidden;
        width: 100%;
        padding-right: 17px;
    }
</style>

<style lang="less" scoped>
  @import "../../less/variables.less";

  .size-lg {
    .modal-container {
      max-width: 960px !important;
    }
  }

  .modal-mask {
    position: fixed;
    z-index: 1002;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    transition: opacity .3s ease;

    .modal-wrapper {
      width: 100%;
      min-height: 100%;
      display: flex;
      padding: 15px;
    }

    &--mobile {
      overflow: hidden;
      display: block;

      .modal-wrapper {
        padding: 0;
        display: block;
        position: absolute;
        z-index: @z-index-modal;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
      }

      .modal-container {
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        margin: 0;
        max-width: none;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        padding: 0;
        max-height: 100%;
      }

      .modal-header {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: @z-index-modal-header;
        padding: 20px 15px 20px 45px;
        background: @primary;
        color: #fff;

        h3 {
          color: #fff;
          margin-bottom: 0;
        }
      }

      .modal-body {
        position: relative;
        padding: 75px 12px 12px 12px;
        margin: 0;
      }

      .modal-cancel {
        top: 25px;
        left: 15px;
        z-index: @z-index-modal-close;
      }
    }

    &--map {
      .modal-container {
        max-width: 1080px;
        width: 100%;
        padding: 0;
      }

      .modal-header {
          padding: 0;
          margin: 0;
          min-height: 0;
          border: 0;
      }

      .modal-body {
        padding: 5px;
        margin: 0;
      }

      .modal-footer {
          padding: 0;
      }

      .modal-cancel {
        top: 15px;
        right: 15px;
        z-index: @z-index-modal-close;
        padding: 4px;
        background: #fff;
        border-radius: 5px;
        font-size: 0;
        line-height: 0;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);

        .icon {
          opacity: 0.6;
          fill: #000;
        }

        &:hover {
          .icon {
            opacity: 1;
          }
        }
      }
    }

    &--big-map {
      .modal-container {
        max-width: 1440px;
      }
    }

    &--advanced-filter {
      .modal-container {
        width: 100%;
        max-width: 1800px;
        padding: 0;
        border: none;
      }

      .modal-header {
        padding: 1px 20px 1px 70px;
        background: @primary;
        color: #fff;

        h3 {
          font-size: 1.5rem;
          color: #fff;
        }
      }

      .modal-body {
        margin: 0;
      }

      .modal-footer {
        padding: 0;
      }

      .modal-cancel {
        top: 10px;
        left: 15px;
        z-index: @z-index-modal-close;
        padding: 4px;
        font-size: 0;
        line-height: 0;

        .icon {
          fill: #fff;
        }

        &:hover {
          .icon {
            opacity: 0.8;
          }
        }
      }
    }

    &--advanced-filter-mobile {
      .modal-body {
          padding: 69px 0px 5px 0px;
        }
    }

    &--full-screen {
      background: #fff;

      .modal-wrapper {
         padding: 0;
      }

      .modal-container {
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        margin: 0;
        max-width: none;
        padding: 0;
        box-shadow: none;
        border: 0;
      }

      .modal-header,
      .modal-body,
      .modal-footer {
        padding: 0;
      }
    }

    &--appointment {
      > .modal-wrapper > .modal-container > .modal-header {
         display: none;
      }

      > .modal-wrapper,
      > .modal-wrapper > .modal-container,
      > .modal-wrapper > .modal-container > .modal-body,
      > .modal-wrapper > .modal-container > .modal-footer {
        padding: 0;
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &--checkout-screen {
      .modal-container {
          max-width: 1200px;
          width: 100%;
          padding: 15px;
      }

      > .modal-wrapper > .modal-container > .modal-header,
      > .modal-wrapper > .modal-container > .modal-footer {
        min-height: 0;
      }

      .modal-body {
        margin: 0;
      }

      .modal-cancel {
        transform: scale(1.5);

        .icon {
          fill: @primary;
          stroke: @primary;
          stroke-width: 1px;
        }
      }

      .modal-cancel-grey {
        transform: scale(1.5);

        .icon {
          fill: #555555;
          stroke: #555555;
          stroke-width: 1px;
        }
      }
    }

    &--redesign {
      .modal-container {
        max-width: 640px;
        padding: 0;
        width: 100%;
        box-shadow: 0px 8px 8px -4px #1018280A;
        border-radius: 20px;
      }
      .modal-body {
        margin-top: 0;
        margin-bottom: 0;
      }
      .modal-cancel {
        z-index: @z-index-modal-close;
        transform: translate(-15px, 15px);
        .icon {
          fill: #070606;
          stroke: #090808;
          stroke-width: .5px;
        }
      }
    }

    &--review {
      .modal-container {
          max-width: 800px;
          width: 100%;
          padding: 40px 40px;
      }

      > .modal-wrapper > .modal-container > .modal-header,
      > .modal-wrapper > .modal-container > .modal-footer {
        min-height: 0;
      }

      .modal-body {
        margin: 0;
      }
    }

    &--community-question {
      .modal-container {
          max-width: 800px;
          width: 100%;
          padding: 15px 40px;
      }

      > .modal-wrapper > .modal-container > .modal-header,
      > .modal-wrapper > .modal-container > .modal-footer {
        min-height: 0;
      }

      .modal-body {
        margin: 0;
      }
    }

    &--community-question-vote {
      .modal-container {
          max-width: 800px;
          width: 100%;
          padding: 15px 40px;
      }

      > .modal-wrapper > .modal-container > .modal-header,
      > .modal-wrapper > .modal-container > .modal-footer {
        min-height: 0;
      }

      .modal-body {
        margin: 0;
      }
    }

    &--description {
      .modal-container {
        max-width: 1000px;
        max-height: 1000px;
        padding: 0;
        border: none;
      }

      .modal-header {
        color: #fff;
        background: @primary;
        padding: 1rem;
        text-align: center;
        font-size: 1.5rem;
        font-weight: 600;
      }

      .modal-body {
        padding: 1.5rem;
        text-align: center;
      }

      .modal-cancel {
        background: @primary;
        padding: 5px;
        border-radius: 50%;
        font-size: 0;
        line-height: 0;
        top: -12px;
        right: -12px;
        -webkit-filter: drop-shadow(2px 2px 2px rgba(0,0,0,0.5));
        filter: drop-shadow(2px 2px 2px rgba(0,0,0,0.5));

        .icon {
          fill: #fff;
        }
      }
    }

    &--map-mobile {
      background: #fff;

      .modal-wrapper {
        padding: 0;
      }

      .modal-container {
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        margin: 0;
        max-width: none;
        padding: 0;
        box-shadow: none;
        border: 0;
      }

      .modal-header {
        padding: 6px 10px 4px;
        min-height: 30px;
      }

      .modal-body,
      .modal-footer {
        padding: 0;
      }

      .modal-body {
        margin: 0;
        position: fixed;
        top: 30px;
        left: 0;
        width: 100%;
        bottom: 0;
      }
    }

    &--iframe {
      background-color: transparent;

      .modal-wrapper {
        padding: 20px;
      }

      .modal-container {
        box-shadow: @box-shadow;
      }
    }
  }

  .modal-container {
    position: relative;
    max-width: 400px;
    border: 1px solid @light-grey;
    box-sizing: border-box;
    margin: auto;
    padding: 30px 20px 26px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-cancel {
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
  }

  .modal-header h3 {
    margin-top: 0;
    color: @black;
  }

  .modal-header {
    padding: 0;
  }

  .modal-body {
    margin: 23px 0 19px;
    padding: 0;
  }

  .modal-footer {
      padding: 0;
  }

  .modal-default-button {
    float: right;
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
</style>



// WEBPACK FOOTER //
// src/components/modal/Modal.vue